import { DEFAULT_APP_STATE } from './App.details';
import StateManager from './StateManager';
import type { AppState } from '../types';

export const appState = new StateManager<AppState>(DEFAULT_APP_STATE);
